import React, { useMemo } from "react";
import Select, { InputActionMeta, StylesConfig } from "react-select";
import AsyncSelect from "react-select/async";
import { Error } from "../InputCustom/styles";

interface Props {
  data: any;
  onChange: (selectedOption: any) => void;
  onInputChange?: (value: string, actionMeta: InputActionMeta) => void;
  inputValue?: string;
  title: string;
  touched?: any;
  error?: any;
  value?: any;
  disabled?: boolean;
  isMulti?: boolean;
  selectRef?: any;
  async?: boolean;
  defaultValue?: any;
  defaultOptions?: any;
  id?: string;
  placeholder?: string;
}

const SelectCustom: React.FC<Props> = (props: Props) => {
  const colourStyles: StylesConfig = {
    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
    control: (styles: any) => ({
      ...styles,
      backgroundColor: "white",
      zIndex: "9999999px",
      borderRadius: "2.313rem",
    }),
    option: (styles: any, state: any) => {
      // const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: state.isDisabled ? "#CCC" : "#FFF",
        fontSize: "0.820rem",
        fontFamily: "Poppins",
        fontWeight: 400,
        color: "#000",
      };
    },
  };

  const defaultValue = useMemo(() => {
    if (props.async || props.isMulti) return props.defaultValue;
    if (props.value === null || props.value === undefined || props.value === "") return null;
    if (typeof props.value === "object") return props.value;
    if (Array.isArray(props.data)) {
      const found = props.data.find((item: any) => item && String(item.value) === String(props.value));
      if (found) return found;
    }
    return null;
  }, [props.async, props.isMulti, props.value, props.data, props.defaultValue]);

  return (
    <>
      <div className="w-full">
        <h1 className="text-sm font-semibold text-[#000] mb-2">
          {props.title}
        </h1>

        {props.async ? (
          <AsyncSelect
            ref={props.selectRef}
            id={props.id}
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={document.body}
            isMulti={props.isMulti}
            defaultOptions={props.defaultOptions}
            defaultValue={defaultValue}
            isDisabled={props.disabled}
            placeholder={props.placeholder || "Selecione"}
            styles={colourStyles}
            name="color"
            loadOptions={props.data}
            onChange={props.onChange}
            onInputChange={props.onInputChange}
            inputValue={props.inputValue}
            value={defaultValue}
            openMenuOnFocus={true} // Abre o menu quando o select recebe foco
            isSearchable={true} // Permite digitação
          />
        ) : (
          <Select
            ref={props.selectRef}
            id={props.id}
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={document.body}
            isMulti={props.isMulti}
            defaultValue={defaultValue}
            isDisabled={props.disabled}
            placeholder={props.placeholder || "Selecione"}
            styles={colourStyles}
            name="color"
            options={props.data}
            onChange={props.onChange}
            onInputChange={props.onInputChange}
            inputValue={props.inputValue}
            value={defaultValue}
            openMenuOnFocus={true} // Abre o menu quando o select recebe foco
            isSearchable={true} // Permite digitação
          />
        )}
      </div>

      {props.touched && props.error && <Error>{props.error}</Error>}
    </>
  );
};

export default SelectCustom;
